const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import ModelData, { IUserData } from "../../../public/model_data";
import { PlayerInfo } from "../hall/hall_view";
import GoldRoomMatchingItem from "./gold_room_matching_item";
import GameUtil from "../../../../utility/game_util";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import AppData from '../../../public/const/app_data';
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview";
import MarqueeComponent from '../marquee/marquee_component';
import GoldRoomItem from "./hundred/gold_room_item";
import { joinUtil } from "../../../public/join_util";
import { IUserCurrencyData } from "../../../../manager/user_manager";

export enum scene_type {
    mango = 0,
    coin = 1,
}

enum bottom_type {
    main = 0,
    addtional = 1,
}

/**
 * 当前场景配置
 */
class currentInfo {

    curScene: scene_type;

    curBottom: bottom_type;

    /**
     * 当前展示的房间列表信息
     */
    currentList: GoldRoomInfo[];
}

@ccclass
export default class GoldEntranceMatchingView extends ViewBase {

    @property(PlayerInfo)
    playerInfo: PlayerInfo = new PlayerInfo()

    @property(cc.Node)
    bgNode: cc.Node = null;

    @property(cc.Node)
    chipNode: cc.Node = null;

    @property(cc.Node)
    goldNode: cc.Node = null;

    @property(cc.Node)
    prefab: cc.Node = null;

    @property(cc.Node)
    top: cc.Node = null;

    @property(cc.Node)
    left: cc.Node = null;

    @property(cc.Node)
    right: cc.Node = null;

    @property(cc.Sprite)
    titile: cc.Sprite = null;

    @property(SpriteFrameHolder)
    iconSprFrameHolder: SpriteFrameHolder = null

    @property(cc.Button)
    leftBtn: cc.Button = null;

    @property(cc.Button)
    rightBth: cc.Button = null;

    @property(cc.Node)
    bottom: cc.Node = null;

    @property(cc.Node)
    item_prefab: cc.Node = null;

    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;

    @property(cc.Node)
    view: cc.Node = null;

    @property(MarqueeComponent)
    marquee: MarqueeComponent = null;

    @property(cc.Node)
    recordBtn: cc.Node = null;

    @property(cc.Node)
    helpBtn: cc.Node = null;

    m_list: GoldRoomInfo[] = []

    // 场次类型(芒果/筹码)   分页类型(前注/后注/无)
    sceneMap: Map<scene_type, Map<bottom_type, GoldRoomInfo[]>>;

    roomList: any[];

    currentInfo: currentInfo;

    m_listView: ListView = null;
    recommendIndex: number = -1;

    chipCach: number = 0;
    goldCash: number = 0;
    pingColor = [new cc.Color(255, 0, 0, 255), new cc.Color(255, 255, 0, 255), new cc.Color(195, 184, 0, 255), new cc.Color(123, 185, 59, 255), new cc.Color(43, 237, 80, 255)]

    sceneTog: scene_type;

    setInfo(data: IUserData) {
        cc.log(data)
        this.playerInfo.avatar.show(true, data.id)
        if (data.matchingChannelId && data.matchingChannelId > 1) {
            this.playerInfo.avatar.labelName.string = data.name + "（独立匹配）"
        }
        // this.playerInfo.id.string = "ID:" + data.idShow
        // this.playerInfo.avatar.spriteFrame = data.avatarSprite
        // this.titile.spriteFrame = this.iconSprFrameHolder.getSpriteFrameByKey(AppData.gameName);
        this.titile.spriteFrame = this.iconSprFrameHolder.getListSpriteFrameByKey(AppData.gameName, "title");
    }

    setGold(data: IUserCurrencyData) {
        this.playerInfo.avatar.showCoinBalance(true)
        this.playerInfo.avatar.refreshCoinBalance(data.chip)
        this.goldCash = data.chip;
        cc.log("setGold", data.chip, this.chipCach)
        // this.playerInfo.gold.string = GameUtil.currencyFormatting(data.gold)// gold.toFixed(2)
    }

    onLoad() {
        // for (let i = 0; i < this.itemList.length; i++) {
        //     this.itemList[i].init();
        // }
        //this._updateListView()
        this.scrollView.enabled = false;

        this.sceneMap = new Map();
        this.sceneTog = scene_type.coin;
        cc.log("load glodentrance----------");
    }

    onShow(intentData) {
        if (intentData == "HallShowGoldEntrance") {
            this.bgNode.opacity = 0
            this.bgNode.runAction(cc.fadeIn(0.3))
        }
    }

    on_item_select() {
        //LogManager.log(data, index);
        //进入房间
    }
    reset() {
        this.m_list = [];
        this.recommendIndex = -1;
        this.chipCach = 0;
        this.goldCash = 0;

        //this.bottom.active = false;
        this._updateListView();

        // this.checkSelectToggle();
        // this.m_listView = null;
    }

    _item_update_func(node: cc.Node, data: any, index: number, xindex: number, item_intact?: any) {
        if (AppData.gameName == "TM_DZPK") {
            var item = node.getComponent(GoldRoomMatchingItem);
            item.setDZPKData(data, index, data.pageIndex, data.isSelect);
        } else {
            var item = node.getComponent(GoldRoomMatchingItem);
            item.setData(data, index, data.isSelect);
        }
    }


    _updateListView() {
        if (this.m_listView) {
            return
        }
        let list: ListView = new ListView({
            scrollview: this.scrollView,
            view: this.view,
            content: this.prefab,
            item_prefab: this.item_prefab,
            cb_host: this,
            item_update_func: this._item_update_func,
            select_cb: this.on_item_select,
            column: 3,
            row: 2,
            gap_y: 50,
            gap_x: 44,
            direction: ListViewDir.Vertical
        });
        this.m_listView = list
    }


    public clear() {

        if (this.m_listView) {
            this.m_listView.set_data([]);
        }
    }

    /**
     * 切换底部分页
     * @param bottomType 
     */
    changeBottomPage(bottomType: bottom_type) {

        this.recommendIndex = -1;

        this.currentInfo.curBottom = bottomType;

        let sceneMap = this.sceneMap.get(this.currentInfo.curScene);
        this.currentInfo.currentList = sceneMap.get(bottomType);

        this.showCurrent();
    }

    /**
     * 切换场次分页
     * @param sceneType 
     */
    changeScenePage(sceneType: scene_type) {

        this.sceneTog = sceneType;

        let bottomMap = this.sceneMap.get(sceneType);

        if (!bottomMap) {
            return;
        }

        this.currentInfo = new currentInfo();

        //切换场次后 底部默认显示main
        this.currentInfo.curBottom = bottom_type.main;
        this.currentInfo.curScene = sceneType;
        this.currentInfo.currentList = bottomMap.get(bottom_type.main);

        this.showCurrent();
    }

    /**
     * 判断场次是否打开
     */
    private checkScene(accountType: number) {

        //修改为渠道不控制游戏匹配场次
        return true;

    }

    updateShow(roomList: any[]) {

        let info: GoldRoomInfo = null;

        let bottomData: { [key: number]: number };

        if (AppData.gameName == "TM_DZPK") {

            bottomData = { 5: 0, 6: 0 };

            for (let index = 0; index < roomList.length; index++) {
                const roomData = roomList[index];
                if (roomData.playTag && this.checkScene(roomData.accountType)) {

                    if (roomData.playTag == "qzc" || roomData.playTag == "1") {

                        bottomData[roomData.accountType]++;
                    }
                    else if (roomData.playTag == "hzc" || roomData.playTag == "2") {

                        bottomData[roomData.accountType]++;
                    }
                }
            }
        } else {

            //除了德州 其他为1
            bottomData = { 5: 1, 6: 1 };

        }

        this.sceneMap.clear();

        let curScene = scene_type.mango;
        let curPage = bottom_type.addtional;

        for (let index = 0; index < roomList.length; index++) {
            const roomData = roomList[index];

            if (!this.checkScene(roomData.accountType)) {
                continue;
            }

            info = new GoldRoomInfo();

            info.goldData = roomData;

            if (roomData.baseScore) {

                info.baseScore = roomData.baseScore;
            }
            if (roomData.gameGoldId) {

                info.gameGoldId = roomData.gameGoldId;
            }

            //从运营服务器获得的场次类型
            //gameData.openChip

            let sceneType = roomData.accountType == 5 ? scene_type.coin : scene_type.mango;
            let pageType: bottom_type;

            if (AppData.gameName == "TM_DZPK") {

                //只有德州分前注 后注 
                if (roomData.playTag) {

                    if (roomData.playTag == "qzc" || roomData.playTag == "1") {
                        //前注场
                        pageType = bottomData[roomData.accountType] > 1 ? bottom_type.addtional : bottom_type.main;

                        this.setRoomData(info, roomData.playRule, sceneType, pageType);

                    } else if (roomData.playTag == "hzc" || roomData.playTag == "2") {
                        //后注场
                        pageType = bottom_type.main;

                        this.setRoomData(info, roomData.playRule, sceneType, pageType);
                    }
                }
            } else if (AppData.gameName == 'TM_QZNN') {
                let rule = JSON.parse(roomData.playRule)
                if (rule.kanPaiCount == 4) {
                    //看牌抢庄
                    pageType = bottom_type.main;
                    this.setRoomData(info, roomData.playRule, sceneType, pageType);

                } else if (rule.kanPaiCount == 0) {
                    //抢庄牛牛
                    pageType = bottom_type.addtional;
                    this.setRoomData(info, roomData.playRule, sceneType, pageType);
                } else {
                    pageType = bottom_type.main;
                    this.setRoomData(info, roomData.playRule, sceneType, pageType);
                }
            }
            else {

                pageType = bottom_type.main;

                this.setRoomData(info, roomData.playRule, sceneType, pageType);
            }

            if (curScene != scene_type.coin) {

                curScene = sceneType;
            }

            if (curPage != bottom_type.main) {

                curPage = pageType;
            }
        };

        let currentList: GoldRoomInfo[] = [];

        let bottomMap: Map<bottom_type, GoldRoomInfo[]> = this.sceneMap.get(scene_type.coin);

        if (!bottomMap) {
            bottomMap = this.sceneMap.get(scene_type.mango);
        }

        if (bottomMap) {
            currentList = bottomMap.get(bottom_type.main)
        }

        this.currentInfo = new currentInfo();

        this.currentInfo.curScene = curScene;
        this.currentInfo.curBottom = curPage;
        this.currentInfo.currentList = currentList;

        this.showCurrent();
    }


    setRoomData(info: GoldRoomInfo, playRule: any, sceneType: scene_type, pageType: bottom_type/*,pageMap : Map<bottom_type,GoldRoomInfo[]>*/) {

        info.InitData(JSON.parse(playRule), sceneType, pageType);

        let list;
        let pageMap = this.sceneMap.get(sceneType);
        if (!pageMap) {
            pageMap = new Map();
        } else {
            list = pageMap.get(pageType);
        }
        if (!list) list = [];
        list.push(info);
        pageMap.set(pageType, list);

        this.sceneMap.set(sceneType, pageMap);
    }



    showCurrent() {

        let curScene: scene_type = this.currentInfo.curScene;
        let curBottom: bottom_type = this.currentInfo.curBottom;

        let sceneSize = this.sceneMap.size;
        let curGame = this.sceneMap.get(curScene);
        let bottomSize = curGame ? curGame.size : 0;

        this.currentInfo.currentList.forEach((current, index) => {
            current.pageIndex = curBottom;
            current.isSelect = (this.recommendIndex == index ? true : false);
        });

        // let sceneTog: cc.Toggle;
        // if (curScene == scene_type.coin) {
        //     sceneTog = cc.find("coin_toggle", this.sceneRadioButton).getComponent(cc.Toggle);

        // } else if (curScene == scene_type.mango) {
        //     sceneTog = cc.find("mango_toggle", this.sceneRadioButton).getComponent(cc.Toggle);
        // }

        // sceneTog.check();
        // this.sceneRadioButton.active = sceneSize > 1;

        let pos_y = this.scrollView.node.position.y;
        this.scrollView.node.position = sceneSize > 1 ? new cc.Vec2(254, pos_y) : new cc.Vec2(204, pos_y);

        this.m_listView.set_data(this.currentInfo.currentList);

        //多分页
        if (bottomSize > 1) {

            this.bottom.active = true;

            this.left.active = curBottom == bottom_type.main;
            this.leftBtn.enabled = curBottom == bottom_type.addtional;

            this.right.active = curBottom == bottom_type.addtional;
            this.rightBth.enabled = curBottom == bottom_type.main;
            this.leftBtn.node.getComponent(cc.Sprite).spriteFrame = this.iconSprFrameHolder.getListSpriteFrameByKey(AppData.gameName + "_bottom", "0");
            this.rightBth.node.getComponent(cc.Sprite).spriteFrame = this.iconSprFrameHolder.getListSpriteFrameByKey(AppData.gameName + "_bottom", "1");
            this.left.getComponent(cc.Sprite).spriteFrame = this.iconSprFrameHolder.getListSpriteFrameByKey(AppData.gameName + "_bottom", "2");
            this.right.getComponent(cc.Sprite).spriteFrame = this.iconSprFrameHolder.getListSpriteFrameByKey(AppData.gameName + "_bottom", "3");

        } else {

            this.bottom.active = false;
        }

        this.refreshRecommendSession();
        ModelData.instance.tableCommonData.isClubTable = false

    }


    /**
     * 根据场景获得当前货币类型
     * @param scene 
     */
    private getCurrency(scene: scene_type) {

        return scene == scene_type.coin ? this.chipCach : this.goldCash;
    }

    update_list_(node: cc.Node, data: any, index: number, item_intact?: any): void {
        var item = node.getComponent(GoldRoomMatchingItem);
        item.setData(data, index, data.isSelect);
    }
    update_list_DZPK_(node: cc.Node, data: any, index: number, xindex: number, item_intact?: any): void {
        var item = node.getComponent(GoldRoomMatchingItem);
        item.setDZPKData(data, index, data.pageIndex, data.isSelect);
    }
    changeTag(gameName: string) {
        if (this.marquee == null) {
            this.marquee = this.top.getChildByName("marquees").getComponent(MarqueeComponent)
        }
        this.marquee.tag = gameName;
        this.marquee.showMarquee(false);
    }

    refreshRecommendSession() {
        //cc.log("this.sessionCash:",this.sessionCash,this.chipCach)

        this.refreshRecommend();

        if (this.m_listView.items) {

            this.m_listView.items.forEach((item, index) => {

                let matchItem: GoldRoomMatchingItem = item.node.getComponent(GoldRoomMatchingItem);
                matchItem.refreshRecommend(index == this.recommendIndex ? true : false);
            });
        }
    }

    refreshRecommend() {

        if (!this.currentInfo || this.currentInfo.currentList.length < 1) {
            //还没初始化
            return;
        }

        let currency = this.getCurrency(this.currentInfo.curScene);
        let currentList = this.currentInfo.currentList;
        this.recommendIndex = -1;

        if (currentList.length > 0) {

            //默认拿第一个做检测
            let findRoom = joinUtil.findRecommend(currency, currentList[0].goldData);
            if (!findRoom) {
                this.recommendIndex = -1;

            } else {
                for (let index = 0; index < currentList.length; index++) {

                    let checkRoom = currentList[index].goldData;
                    if (findRoom.roomData.gameGoldId == checkRoom.gameGoldId) {
                        this.recommendIndex = index;
                        break;
                    }

                }
            }
        }
    }

    /**
     * 充值检测
     */
    checkRecharge() {

        let currency = this.getCurrency(this.currentInfo.curScene);
        let currentList = this.currentInfo.currentList;

        if (currentList && currentList.length > 0) {

            let roomData = currentList[0];
            let findRoom = joinUtil.findRecommend(currency, roomData.goldData);
            if (!findRoom) {
                joinUtil.showRecharge(this, false, roomData.goldData);
            }
        }

    }

    onToggleCoin() {

        this.changeScenePage(scene_type.coin);
    }

    onToggleMango() {

        this.changeScenePage(scene_type.mango);
    }

    onDestroy() {

    }
}
export class GoldRoomInfo {
    //底注
    baseScore: number = 0;

    gameGoldId: number = 0;
    //准入上限
    minJoinCoin: number = 0;
    //准入上限
    maxJoinCoin: number = 0;
    //前注
    preBet: number = 0;
    //最小下注
    smallBet: number = 0;
    //最大下注
    bigBet: number = 0;

    roomType: number = -1;

    goldData: any = null;

    minTake: number = 0;

    maxTake: number = 0;

    sceneIndex: number = 0;

    pageIndex: number = 1;

    isSelect: boolean = false;

    pageType: bottom_type;

    sceneType: scene_type;

    openLevel: number = 0;

    playRule: any;

    public InitData(rule: any, sceneType: scene_type, pageType: bottom_type) {

        if (rule.game_BetSingle) {
            this.baseScore = Number(rule.game_BetSingle);
        }
        if (rule.pub_AllowNum) {
            this.minJoinCoin = Number(rule.pub_AllowNum);
        }
        if (rule.pub_AllowNumMax) {
            this.maxJoinCoin = Number(rule.pub_AllowNumMax);
        }
        if (rule.game_BetPre) {
            this.preBet = Number(rule.game_BetPre);
        }
        if (rule.game_SmallBlind) {
            this.smallBet = Number(rule.game_SmallBlind);
        }
        if (rule.game_BigBlind) {
            this.bigBet = Number(rule.game_BigBlind);
        }
        if (rule.game_BetMin) {
            this.smallBet = Number(rule.game_BetMin);
        }
        if (rule.game_BetMax) {
            this.bigBet = Number(rule.game_BetMax);
        }
        if (rule.pub_RoomType) {
            this.roomType = Number(rule.pub_RoomType);
        }
        if (rule.game_BetTakeMin) {
            this.minTake = Number(rule.game_BetTakeMin);
        }
        if (rule.game_BetTakeMax) {
            this.maxTake = Number(rule.game_BetTakeMax);
        }
        if (rule.pub_Level) {
            this.openLevel = Number(rule.pub_Level)
        }

        this.sceneType = sceneType;
        this.pageType = pageType;
        this.playRule = rule;
    }
    index?
    labelFont?: cc.Font[];
    labelColor?: cc.Color[];
}
